'use client';

import dynamic from 'next/dynamic';

// `next/dynamic(..., { ssr: false })` isn't allowed directly inside a Server Component
// (the root layout) — this one-line client wrapper is the standard way around that: the
// layout imports this (a plain, always-present client component reference) rather than
// calling `dynamic()` itself, and the actual code-splitting/ssr:false happens in here.
const OpenReplay = dynamic(() => import('./OpenReplay'), { ssr: false });

export default OpenReplay;
